// extracted by mini-css-extract-plugin
export var copyIcon = "_r9-2";
export var discountCard = "_r9-0";
export var discountCode = "_r9-3";
export var discountContent = "_r9-1";
export var loadingCard = "_r9-4";